export type PlayerMetadata = Record<string, unknown> | null | undefined;

export function getPlayerAuthUserId(metadata: PlayerMetadata): string | null {
  if (!metadata || typeof metadata !== "object") return null;
  const authUserId = metadata.auth_user_id;
  return typeof authUserId === "string" && authUserId.length > 0 ? authUserId : null;
}

export function isPlayerLinkedToUser(metadata: PlayerMetadata): boolean {
  return getPlayerAuthUserId(metadata) !== null;
}
